import styled from 'styled-components';

export const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const StyledSelect = styled.select`
  appearance: none;
  padding: 8px 32px;
  border-radius: 6px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 14px;
  color: inherit;

  
  &:focus {
    outline: none;
    border-color: #4a90e2;
    box-shadow: 0 0 0 1px #4a90e2;
  }
`;

export const StyledOption = styled.option`
  padding: 8px;
  background-color: #fff; /* Or your desired background */
  color: #333; /* Or your desired text color */
`;

